import React from "react";
import { Link } from "react-router-dom";
import { logo } from "../constant";

const Footer = () => {
  const dateyear = new Date();
  const thisyear = dateyear.getFullYear();
  return (
    <>
      {/* footer starts here */}
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="footer-widget-wrapper">
                <div className="footer-heading-wrapper">
                  <h6>Navigations</h6>
                </div>
                <div className="footer-links-wrapper">
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/">About Us</Link>
                    </li>
                    <li>
                      <Link to="/">Why Electric</Link>
                    </li>
                    <li>
                      <Link to="/">Contact Us</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="footer-widget-wrapper">
                <div className="footer-heading-wrapper">
                  <h6>Quick Links</h6>
                </div>
                <div className="footer-links-wrapper">
                  <ul>
                    <li>
                      <Link to="/">Inventory</Link>
                    </li>
                    <li>
                      <Link to="/">Sell Your Ev</Link>
                    </li>
                    <li>
                      <Link to="/">Get Approved</Link>
                    </li>
                    <li>
                      <Link to="/">Our Blogs</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="footer-widget-wrapper">
                <div className="footer-heading-wrapper">
                  <h6>Find Help</h6>
                </div>
                <div className="footer-links-wrapper">
                  <ul>
                    <li>
                      <Link to="/">Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="/">Terms & Conditions</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="footer-widget-wrapper footer-icons-wrapper">
                <div className="footer-heading-wrapper">
                  <h6>Conatct Us</h6>
                </div>
                <div className="footer-links-wrapper">
                  <ul>
                    <li>
                      <Link to="">
                        <span className="icon">
                          <i class="fa-regular fa-building"></i>
                        </span>
                        <span className="text">
                          Lorem ipsum dolor sit amet, conectetur adipiscing
                          elit.
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="mailto:Info@evolvingmotors.com">
                        <span className="icon">
                          <i class="fa-solid fa-envelope"></i>
                        </span>
                        <span className="text">Info@evolvingmotors.com</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="tel:12345678910">
                        <span className="icon">
                          <i class="fa-solid fa-phone"></i>
                        </span>
                        <span className="text">+1 234 567 8910</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="">
                        <span className="icon">
                          <i class="fa-solid fa-location-dot"></i>
                        </span>
                        <span className="text">
                          Lorem ipsum dolor sit amet, conectetur adipiscing
                          elit.
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-5">
            <div className="col-lg-6">
              <div className="logo-wrapper">
                <Link>
                  <img src={logo} className="img-fluid" alt="" />
                </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="social-icons-wrapper">
                <ul>
                  <li>
                    <a href="#">
                      <i class="fa-brands fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa-brands fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa-brands fa-youtube"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa-brands fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa-brands fa-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="copyright-wrapper">
                <p>© {thisyear} – evolvingmotors.All Rights Reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* footer ends here */}
    </>
  );
};

export default Footer;
